import type { IOrgStorageService } from "@/application/ports/services/IOrgStorageService";
import type { IStorageService } from "@/application/ports/services";
import { STORAGE_KEYS } from "./constants";

export class OrgStorageService implements IOrgStorageService {
  constructor(private storageService: IStorageService) {}

  getCurrentOrgUuid(): string | null {
    return this.storageService.get<string>(STORAGE_KEYS.CURRENT_ORG_UUID);
  }

  setCurrentOrgUuid(uuid: string): void {
    this.storageService.set(STORAGE_KEYS.CURRENT_ORG_UUID, uuid);
  }
}
